import {
  IsArray,
  IsDateString,
  IsEnum,
  IsOptional,
  IsUUID,
  ArrayMinSize,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { CLASS_ROLE_CODES } from '../../../constants/class-membership.constants'

/** Codes de rôles valides pour validation */
const VALID_ROLE_CODES = Object.values(CLASS_ROLE_CODES)

/**
 * DTO pour ajouter plusieurs membres à une classe (bulk)
 *
 * Utilisation:
 * - Fournir soit `roleId` (UUID) soit `roleCode` (STUDENT, TEACHER, etc.)
 * - Si aucun n'est fourni, le rôle par défaut est STUDENT
 */
export class AddClassMembersDto {
  @ApiProperty({
    description: 'IDs des utilisateurs à ajouter à la classe',
    type: [String],
    example: ['uuid-1', 'uuid-2', 'uuid-3'],
  })
  @IsArray()
  @ArrayMinSize(1, { message: 'Au moins un utilisateur doit être spécifié' })
  @IsUUID('4', {
    each: true,
    message: 'Chaque userId doit être un UUID v4 valide',
  })
  userIds!: string[]

  @ApiPropertyOptional({ type: 'string', description: 'ID UUID du rôle de classe (prioritaire sur roleCode)' })
  @IsOptional()
  @IsUUID('4')
  roleId?: string

  @ApiPropertyOptional({
    type: 'string',
    description: 'Code du rôle de classe. Utilisé si roleId non fourni.',
    example: 'STUDENT',
    enum: VALID_ROLE_CODES,
  })
  @IsOptional()
  @IsEnum(VALID_ROLE_CODES, {
    message: `roleCode doit être l'un des suivants: ${VALID_ROLE_CODES.join(', ')}`,
  })
  roleCode?: string

  @ApiPropertyOptional({
    type: 'string',
    description: "Date d'adhésion (par défaut: maintenant)",
    example: '2024-01-15T08:00:00Z',
  })
  @IsOptional()
  @IsDateString()
  joinedAt?: string
}
